module.exports = __webpack_public_path__ + "static/img/icon-01.19568b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/icon-01.png
// module id = 4+gr
// module chunks = 1